import {
  isInvalidMeidenConnectAuthorizationStateError,
  MeidenConnectInvalidAuthorizationStateRecoveryPane,
} from "@osakabe/auth-service-provider";
import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  readonly children: ReactNode;
}

interface State {
  readonly error: Error | null;
}

// アプリ全体の例外を受けて、フォールバック UI を表示する。
// 本番では sentry / cloudwatch 等への送信を将来追加する。
export class RootErrorBoundary extends Component<Props, State> {
  public state: State = { error: null };

  public static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[RootErrorBoundary]", error, info);
  }

  public render(): ReactNode {
    if (this.state.error) {
      if (isInvalidMeidenConnectAuthorizationStateError(this.state.error)) {
        return <MeidenConnectInvalidAuthorizationStateRecoveryPane />;
      }

      return (
        <div role="alert" style={{ padding: "32px", fontFamily: "var(--font-stack)" }}>
          <h1>申し訳ありません。エラーが発生しました。</h1>
          <p>ページを再読み込みしてください。問題が続く場合は管理者へ連絡してください。</p>
          <pre style={{ whiteSpace: "pre-wrap" }}>{this.state.error.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
